/* eslint-disable no-untranslated-string/no-untranslated-string */
export interface ITimezoneGroup {
  groupName: string;
  result: ITimezone[];
}

export interface ITimezone {
  category: string;
  country: string;
  code: string;
  name: string;
  dstCode?: string;
  dstName?: string;
  locations: string;
  value: string;
}

export const getLocalTimezone = () => {
  const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezoneName === 'Europe/Kiev') {
    return 'Europe/Kyiv';
  }
  return timezoneName;
};

export const TIMEZONE_LIST: ITimezoneGroup[] = [
  {
    groupName: 'US & Canada',
    result: [
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'EST',
        dstCode: 'EDT',
        name: 'Eastern Standard Time',
        dstName: 'Eastern Daylight Time',
        locations: 'New York City, Miami',
        value: 'America/New_York',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'CST',
        dstCode: 'CDT',
        name: 'Central Standard Time',
        dstName: 'Central Daylight Time',
        locations: 'Chicago, Dallas',
        value: 'America/Chicago',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'MST',
        name: 'Mountain Standard Time',
        locations: 'Phoenix, Arizona',
        value: 'America/Phoenix',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'MDT',
        name: 'Mountain Daylight Time',
        locations: 'Denver, El Paso',
        value: 'America/Denver',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'PST',
        dstCode: 'PDT',
        name: 'Pacific Standard Time',
        dstName: 'Pacific Daylight Time',
        locations: 'Los Angeles, Seattle',
        value: 'America/Los_Angeles',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'AKST',
        dstCode: 'AKDT',
        name: 'Alaska Standard Time',
        dstName: 'Alaska Daylight Time',
        locations: 'Anchorage, Juneau',
        value: 'America/Anchorage',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'HADT',
        name: 'Hawaii-Aleutian Daylight Time',
        locations: 'Adak (Aleutian Islands)',
        value: 'America/Adak',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'HAST',
        name: 'Hawaii-Aleutian Standard Time',
        locations: 'Honolulu, Hilo',
        value: 'Pacific/Honolulu',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Puerto Rico',
        value: 'America/Puerto_Rico',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'SST',
        name: 'Samoa Standard Time',
        locations: 'American Samoa',
        value: 'Pacific/Pago_Pago',
      },
      {
        category: 'US & Canada',
        country: 'USA',
        code: 'ChST',
        name: 'Chamorro Standard Time',
        locations: 'Guam, Saipan',
        value: 'Pacific/Guam',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'Atikokan',
        value: 'America/Atikokan',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'EDT',
        name: 'Eastern Daylight Time',
        locations: 'Ontario, Toronto',
        value: 'America/Toronto',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'Saskatoon, Regina',
        value: 'America/Regina',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'DST',
        name: 'Central Daylight Time',
        locations: 'Winnipeg, Brandon',
        value: 'America/Winnipeg',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Blanc-Sablon',
        value: 'America/Blanc-Sablon',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'ADT',
        name: 'Atlantic Daylight Time',
        locations: 'Halifax, Moncton',
        value: 'America/Moncton',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'PST',
        dstCode: 'PDT',
        name: 'Pacific Standard Time',
        dstName: 'Pacific Daylight Time',
        locations: 'British Columbia',
        value: 'America/Vancouver',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'MST',
        dstCode: 'MDT',
        name: 'Mountain Standard Time',
        dstName: 'Mountain Daylight Time',
        locations: 'Alberta, Nunavut',
        value: 'America/Edmonton',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'NST',
        dstCode: 'NDT',
        name: 'Newfoundland Standard Time',
        dstName: 'Newfoundland Daylight Time',
        locations: 'Newfoundland and Labrador',
        value: 'America/St_Johns',
      },
      {
        category: 'US & Canada',
        country: 'Canada',
        code: 'YT',
        name: 'Yukon Time',
        locations: 'Yukon',
        value: 'America/Whitehorse',
      },
    ],
  },
  {
    groupName: 'America',
    result: [
      {
        category: 'America',
        country: 'Brazil',
        code: 'ACT',
        name: 'Acre Time',
        locations: 'Rio Branco, Cruzeiro do Sul',
        value: 'America/Rio_Branco',
      },
      {
        category: 'America',
        country: 'Brazil',
        code: 'AMT',
        name: 'Amazon Standard Time',
        locations: 'Manaus, Campo Grande',
        value: 'America/Manaus',
      },
      {
        category: 'America',
        country: 'Brazil',
        code: 'BRT',
        name: 'Brasilia Standard Time',
        locations: 'São Paulo, Rio de Janeiro',
        value: 'America/Sao_Paulo',
      },
      {
        category: 'America',
        country: 'Brazil',
        code: 'FNT',
        name: 'Fernando de Noronha Standard Time',
        locations: 'Noronha',
        value: 'America/Noronha',
      },
      {
        category: 'America',
        country: 'The Bahamas',
        code: 'EST',
        dstCode: 'EDT',
        name: 'Eastern Standard Time',
        dstName: 'Eastern Daylight Time',
        locations: 'Nassau, Lucaya',
        value: 'America/Nassau',
      },
      {
        category: 'America',
        country: 'Cayman Islands',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'George Town, West Bay',
        value: 'America/Cayman',
      },
      {
        category: 'America',
        country: 'Haiti',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'Port-au-Prince, Gonaïves',
        value: 'America/Port-au-Prince',
      },
      {
        category: 'America',
        country: 'Jamaica',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'Kingston, Spanish Town',
        value: 'America/Jamaica',
      },
      {
        category: 'America',
        country: 'Panama',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'Panama City, Colón',
        value: 'America/Panama',
      },
      {
        category: 'America',
        country: 'Turks and Caicos Islands',
        code: 'EST',
        name: 'Eastern Standard Time',
        locations: 'Cockburn Town, Providenciales',
        value: 'America/Grand_Turk',
      },
      {
        category: 'America',
        country: 'America',
        code: 'ART',
        name: 'Argentina Standard Time',
        locations: 'Buenos Aires, Córdoba',
        value: 'America/Argentina/Buenos_Aires',
      },
      {
        category: 'America',
        country: 'Saint Kitts and Nevis',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Basseterre, Charlestown',
        value: 'America/St_Kitts',
      },
      {
        category: 'America',
        country: 'Dominica',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Roseau',
        value: 'America/Dominica',
      },
      {
        category: 'America',
        country: 'Saint Lucia',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Castries',
        value: 'America/St_Lucia',
      },
      {
        category: 'America',
        country: 'Saint Vincent and the Grenadines',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Kingstown',
        value: 'America/St_Vincent',
      },
      {
        category: 'America',
        country: 'Antigua and Barbuda',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: "St. John's",
        value: 'America/Antigua',
      },
      {
        category: 'America',
        country: 'Barbados',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Bridgetown',
        value: 'America/Barbados',
      },
      {
        category: 'America',
        country: 'Anguilla',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'The Valley',
        value: 'America/Anguilla',
      },
      {
        category: 'America',
        country: 'British Virgin Islands',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Road Town',
        value: 'America/Tortola',
      },
      {
        category: 'America',
        country: 'Aruba',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Oranjestad',
        value: 'America/Aruba',
      },
      {
        category: 'America',
        country: 'Curaçao',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Willemstad',
        value: 'America/Curacao',
      },
      {
        category: 'America',
        country: 'Caribbean Netherlands',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Kralendijk',
        value: 'America/Kralendijk',
      },
      {
        category: 'America',
        country: 'Saint Barthélemy',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Gustavia',
        value: 'America/St_Barthelemy',
      },
      {
        category: 'America',
        country: 'Saint Martin',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Marigot',
        value: 'America/Marigot',
      },
      {
        category: 'America',
        country: 'Sint Maarten',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Philipsburg',
        value: 'America/Lower_Princes',
      },
      {
        category: 'America',
        country: 'Trinidad and Tobago',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Port of Spain',
        value: 'America/Port_of_Spain',
      },
      {
        category: 'America',
        country: 'Virgin Islands (U.S.)',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Charlotte Amalie',
        value: 'America/Virgin',
      },
      {
        category: 'America',
        country: 'Puerto Rico',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'San Juan',
        value: 'America/Puerto_Rico',
      },
      {
        category: 'America',
        country: 'Grenada',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: "St. George's",
        value: 'America/Grenada',
      },
      {
        category: 'America',
        country: 'Martinique',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Fort-de-France',
        value: 'America/Martinique',
      },
      {
        category: 'America',
        country: 'Guadeloupe',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Pointe-à-Pitre',
        value: 'America/Guadeloupe',
      },
      {
        category: 'America',
        country: 'Montserrat',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Saint John',
        value: 'America/Montserrat',
      },
      {
        category: 'America',
        country: 'Bermuda',
        code: 'AST',
        name: 'Atlantic Standard Time',
        locations: 'Hamilton',
        value: 'Atlantic/Bermuda',
      },
      {
        category: 'America',
        country: 'Bolivia',
        code: 'BOT',
        name: 'Bolivia Time',
        locations: 'La Paz, Santa Cruz de la Sierra',
        value: 'America/La_Paz',
      },
      {
        category: 'America',
        country: 'Belize',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'Belmopan',
        value: 'America/Belize',
      },
      {
        category: 'America',
        country: 'Costa Rica',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'San José',
        value: 'America/Costa_Rica',
      },
      {
        category: 'America',
        country: 'El Salvador',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'San Salvador',
        value: 'America/El_Salvador',
      },
      {
        category: 'America',
        country: 'Guatemala',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'Guatemala City',
        value: 'America/Guatemala',
      },
      {
        category: 'America',
        country: 'Honduras',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'Tegucigalpa',
        value: 'America/Tegucigalpa',
      },
      {
        category: 'America',
        country: 'Nicaragua',
        code: 'CST',
        name: 'Central Standard Time',
        locations: 'Managua',
        value: 'America/Managua',
      },
      {
        category: 'America',
        country: 'Mexico',
        code: 'CST',
        dstCode: 'CDT',
        name: 'Central Standard Time',
        dstName: 'Central Daylight Time',
        locations: 'Mexico City, Guadalajara',
        value: 'America/Mexico_City',
      },
      {
        category: 'America',
        country: 'Mexico',
        code: 'MDT',
        name: 'Mountain Daylight Time',
        locations: 'Chihuahua',
        value: 'America/Chihuahua',
      },
      {
        category: 'America',
        country: 'Mexico',
        code: 'MST',
        name: 'Mountain Standard Time',
        locations: 'Hermosillo',
        value: 'America/Hermosillo',
      },
      {
        category: 'America',
        country: 'Mexico',
        code: 'PST',
        dstCode: 'PDT',
        name: 'Pacific Standard Time',
        dstName: 'Pacific Daylight Time',
        locations: 'Tijuana',
        value: 'America/Tijuana',
      },
      {
        category: 'America',
        country: 'Chile',
        code: 'CLT',
        dstCode: 'CLST',
        name: 'Chile Standard Time',
        dstName: 'Chile Summer Time',
        locations: 'Santiago, Valparaíso',
        value: 'America/Santiago',
      },
      {
        category: 'America',
        country: 'Colombia',
        code: 'COT',
        name: 'Colombia Time',
        locations: 'Bogotá, Medellín, Cali',
        value: 'America/Bogota',
      },
      {
        category: 'America',
        country: 'Cuba',
        code: 'CST',
        dstCode: 'CDT',
        name: 'Cuba Standard Time',
        dstName: 'Cuba Daylight Time',
        locations: 'Havana, Santiago de Cuba',
        value: 'America/Havana',
      },
      {
        category: 'America',
        country: 'Greenland',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Scoresbysund',
        value: 'America/Scoresbysund',
      },
      {
        category: 'America',
        country: 'Greenland',
        code: 'EGT',
        name: 'Eastern Greenland Time',
        locations: 'Danmarkshavn',
        value: 'America/Danmarkshavn',
      },
      {
        category: 'America',
        country: 'Greenland',
        code: 'WGT',
        dstCode: 'WGST',
        name: 'West Greenland Time',
        dstName: 'West Greenland Summer Time',
        locations: 'Nuuk',
        value: 'America/Godthab',
      },
      {
        category: 'America',
        country: 'Greenland',
        code: 'CGT',
        name: 'Central Greenland Time',
        locations: 'Pituffik',
        value: 'America/Thule',
      },
      {
        category: 'America',
        country: 'French Guiana',
        code: 'GFT',
        name: 'French Guiana Time',
        locations: 'French Guiana',
        value: 'America/Cayenne',
      },
      {
        category: 'America',
        country: 'Guyana',
        code: 'GYT',
        name: 'Guyana Time',
        locations: 'Guyana',
        value: 'America/Guyana',
      },
      {
        category: 'America',
        country: 'Paraguay',
        code: 'PYST',
        name: 'Paraguay Time',
        locations: 'Paraguay',
        value: 'America/Asuncion',
      },
      {
        category: 'America',
        country: 'Peru',
        code: 'PET',
        name: 'Peru Time',
        locations: 'Peru',
        value: 'America/Lima',
      },
      {
        category: 'America',
        country: 'Saint Pierre and Miquelon',
        code: 'PMT',
        name: 'Saint Pierre and Miquelon Time',
        locations: 'Saint Pierre and Miquelon',
        value: 'America/Miquelon',
      },
      {
        category: 'America',
        country: 'Suriname',
        code: 'SAST',
        name: 'Suriname Time',
        locations: 'Suriname',
        value: 'America/Paramaribo',
      },
      {
        category: 'America',
        country: 'Uruguay',
        code: 'UYT',
        name: 'Uruguay Standard Time',
        locations: 'Uruguay',
        value: 'America/Montevideo',
      },
      {
        category: 'America',
        country: 'Venezuela',
        code: 'VET',
        name: 'Venezuela Time',
        locations: 'Venezuela',
        value: 'America/Caracas',
      },
      {
        category: 'America',
        country: 'Ecuador',
        code: 'ECT',
        name: 'Ecuador Time',
        locations: 'Quito, Guayaquil',
        value: 'America/Guayaquil',
      },
      {
        category: 'America',
        country: 'Ecuador',
        code: 'GALT',
        name: 'Galápagos Time',
        locations: 'Puerto Baquerizo Moreno',
        value: 'Pacific/Galapagos',
      },
    ],
  },
  {
    groupName: 'Europe',
    result: [
      {
        category: 'Europe',
        country: 'Croatia',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Zagreb, Split',
        value: 'Europe/Zagreb',
      },
      {
        category: 'Europe',
        country: 'Poland',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Warsaw, Łódź',
        value: 'Europe/Warsaw',
      },
      {
        category: 'Europe',
        country: 'Lithuania',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Vilnius, Kaunas',
        value: 'Europe/Vilnius',
      },
      {
        category: 'Europe',
        country: 'Estonia',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Tallinn, Tartu',
        value: 'Europe/Tallinn',
      },
      {
        category: 'Europe',
        country: 'Bulgaria',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Sofia, Plovdiv',
        value: 'Europe/Sofia',
      },
      {
        category: 'Europe',
        country: 'Austria',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Vienna, Graz',
        value: 'Europe/Vienna',
      },
      {
        category: 'Europe',
        country: 'Sweden',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Stockholm, Gothenburg',
        value: 'Europe/Stockholm',
      },
      {
        category: 'Europe',
        country: 'Albania',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Tirana, Durrës',
        value: 'Europe/Tirane',
      },
      {
        category: 'Europe',
        country: 'United Kingdom',
        code: 'GMT',
        dstCode: 'BST',
        name: 'Greenwich Mean Time',
        dstName: 'British Summer Time',
        locations: 'London, Edinburgh',
        value: 'Europe/London',
      },
      {
        category: 'Europe',
        country: 'Slovakia',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Bratislava, Kosice',
        value: 'Europe/Bratislava',
      },
      {
        category: 'Europe',
        country: 'Belgium',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Brussels, Antwerp',
        value: 'Europe/Brussels',
      },
      {
        category: 'Europe',
        country: 'Romania',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Bucharest, Cluj-Napoca',
        value: 'Europe/Bucharest',
      },
      {
        category: 'Europe',
        country: 'Hungary',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Budapest, Debrecen',
        value: 'Europe/Budapest',
      },
      {
        category: 'Europe',
        country: 'Germany',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Berlin, Munich',
        value: 'Europe/Berlin',
      },
      {
        category: 'Europe',
        country: 'Moldova',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Chisinau, Tiraspol',
        value: 'Europe/Chisinau',
      },
      {
        category: 'Europe',
        country: 'Denmark',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Copenhagen, Aarhus',
        value: 'Europe/Copenhagen',
      },
      {
        category: 'Europe',
        country: 'Andorra',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Andorra la Vella',
        value: 'Europe/Andorra',
      },
      {
        category: 'Europe',
        country: 'Netherlands',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Amsterdam, Rotterdam',
        value: 'Europe/Amsterdam',
      },
      {
        category: 'Europe',
        country: 'Greece',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Athens, Thessaloniki',
        value: 'Europe/Athens',
      },
      {
        category: 'Europe',
        country: 'Ireland',
        code: 'IST',
        dstCode: 'GMT',
        name: 'Irish Standard Time',
        dstName: 'Greenwich Mean Time*',
        locations: 'Dublin, Cork',
        value: 'Europe/Dublin',
      },
      {
        category: 'Europe',
        country: 'Gibraltar',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Gibraltar',
        value: 'Europe/Gibraltar',
      },
      {
        category: 'Europe',
        country: 'Guernsey',
        code: 'GMT',
        dstCode: 'BST',
        name: 'Greenwich Mean Time',
        dstName: 'British Summer Time',
        locations: 'St. Peter Port',
        value: 'Europe/Guernsey',
      },
      {
        category: 'Europe',
        country: 'Finland',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Helsinki, Espoo',
        value: 'Europe/Helsinki',
      },
      {
        category: 'Europe',
        country: 'Isle of Man',
        code: 'GMT',
        dstCode: 'BST',
        name: 'Greenwich Mean Time',
        dstName: 'British Summer Time',
        locations: 'Douglas',
        value: 'Europe/Isle_of_Man',
      },
      {
        category: 'Europe',
        country: 'Turkey',
        code: 'TRT',
        name: 'Turkey Time',
        locations: 'Istanbul, Ankara',
        value: 'Europe/Istanbul',
      },
      {
        category: 'Europe',
        country: 'Jersey',
        code: 'GMT',
        dstCode: 'BST',
        name: 'Greenwich Mean Time',
        dstName: 'British Summer Time',
        locations: 'St. Helier',
        value: 'Europe/Jersey',
      },
      {
        category: 'Europe',
        country: 'Serbia',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Belgrade, Pristina, Prizren',
        value: 'Europe/Belgrade',
      },
      {
        category: 'Europe',
        country: 'Ukraine',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Kyiv, Kharkiv',
        value: 'Europe/Kyiv',
      },
      {
        category: 'Europe',
        country: 'Portugal',
        code: 'WET',
        dstCode: 'WEST',
        name: 'Western European Time',
        dstName: 'Western European Summer Time',
        locations: 'Lisbon, Porto',
        value: 'Europe/Lisbon',
      },
      {
        category: 'Europe',
        country: 'Slovenia',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Ljubljana, Maribor',
        value: 'Europe/Ljubljana',
      },
      {
        category: 'Europe',
        country: 'Luxembourg',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Luxembourg',
        value: 'Europe/Luxembourg',
      },
      {
        category: 'Europe',
        country: 'Spain',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Madrid, Barcelona',
        value: 'Europe/Madrid',
      },
      {
        category: 'Africa',
        country: 'Spain',
        code: 'CET',
        name: 'Central European Time',
        locations: 'Ceuta',
        value: 'Africa/Ceuta',
      },
      {
        category: 'Europe',
        country: 'Malta',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Valletta, Birkirkara',
        value: 'Europe/Malta',
      },
      {
        category: 'Europe',
        country: 'Belarus',
        code: 'MSK',
        name: 'Moscow Standard Time',
        locations: 'Minsk, Gomel',
        value: 'Europe/Minsk',
      },
      {
        category: 'Europe',
        country: 'Monaco',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Monaco',
        value: 'Europe/Monaco',
      },
      {
        category: 'Europe',
        country: 'Cyprus',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Nicosia, Limassol',
        value: 'Asia/Nicosia',
      },
      {
        category: 'Europe',
        country: 'Norway',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Oslo, Bergen',
        value: 'Europe/Oslo',
      },
      {
        category: 'Europe',
        country: 'France',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Paris, Marseille',
        value: 'Europe/Paris',
      },

      {
        category: 'Europe',
        country: 'Montenegro',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Podgorica, Nikšić',
        value: 'Europe/Podgorica',
      },
      {
        category: 'Europe',
        country: 'Czech Republic',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Prague, Brno',
        value: 'Europe/Prague',
      },
      {
        category: 'Europe',
        country: 'Latvia',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Riga, Daugavpils',
        value: 'Europe/Riga',
      },
      {
        category: 'Europe',
        country: 'Italy',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Rome, Milan',
        value: 'Europe/Rome',
      },
      {
        category: 'Europe',
        country: 'Russia',
        code: 'MSK',
        name: 'Moscow Standard Time',
        locations: 'Moscow, St. Petersburg',
        value: 'Europe/Moscow',
      },
      {
        category: 'Europe',
        country: 'Russia',
        code: 'SAMT',
        name: 'Samara Time',
        locations: 'Samara, Tolyatti, Saratov',
        value: 'Europe/Samara',
      },
      {
        category: 'Europe',
        country: 'Switzerland',
        code: 'CET',
        dstCode: 'CEST',
        name: 'Central European Time',
        dstName: 'Central European Summer Time',
        locations: 'Zurich, Geneva, Basel',
        value: 'Europe/Zurich',
      },
      {
        category: 'Europe',
        country: 'Iceland',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Reykjavik',
        value: 'Atlantic/Reykjavik',
      },
    ],
  },
  {
    groupName: 'Australia',
    result: [
      {
        category: 'Australia',
        country: 'Australia',
        code: 'ACDT',
        name: 'Australian Central Daylight Time',
        locations: 'Adelaide',
        value: 'Australia/Adelaide',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'ACST',
        name: 'Australian Central Standard Time',
        locations: 'Darwin, Alice Springs',
        value: 'Australia/Darwin',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'ACWST',
        name: 'Australian Central Western Standard Time',
        locations: 'Eucla',
        value: 'Australia/Eucla',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'AEDT',
        name: 'Australian Eastern Daylight Time',
        locations: 'Sydney, Melbourne',
        value: 'Australia/Sydney',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'AEST',
        name: 'Australian Eastern Standard Time',
        locations: 'Brisbane, Gold Coast',
        value: 'Australia/Brisbane',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'AWST',
        name: 'Australian Western Standard Time',
        locations: 'Perth',
        value: 'Australia/Perth',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'AWST',
        name: 'Australian Western Standard Time',
        locations: 'Casey',
        value: 'Antarctica/Casey',
      },
      {
        category: 'Australia',
        country: 'Australia',
        code: 'LHDT',
        name: 'Lord Howe Daylight Time',
        locations: 'Lord Howe Island',
        value: 'Australia/Lord_Howe',
      },
    ],
  },
  {
    groupName: 'Pacific',
    result: [
      {
        category: 'Pacific',
        country: 'New Zealand',
        code: 'NZST',
        dstCode: 'NZDT',
        name: 'New Zealand Standard Time',
        dstName: 'New Zealand Daylight Time',
        locations: 'Auckland, Wellington',
        value: 'Pacific/Auckland',
      },
      {
        category: 'Pacific',
        country: 'Papua New Guinea',
        code: 'PGT',
        name: 'Papua New Guinea Time',
        locations: 'Port Moresby',
        value: 'Pacific/Port_Moresby',
      },
      {
        category: 'Pacific',
        country: 'Fiji',
        code: 'FJT',
        name: 'Fiji Time',
        locations: 'Suva',
        value: 'Pacific/Fiji',
      },
      {
        category: 'Pacific',
        country: 'Solomon Islands',
        code: 'SBT',
        name: 'Solomon Islands Time',
        locations: 'Honiara',
        value: 'Pacific/Guadalcanal',
      },
      {
        category: 'Pacific',
        country: 'Vanuatu',
        code: 'VUT',
        name: 'Vanuatu Time',
        locations: 'Port Vila',
        value: 'Pacific/Efate',
      },
      {
        category: 'Pacific',
        country: 'Kiribati',
        code: 'GILT',
        name: 'Gilbert Islands Time',
        locations: 'Tarawa',
        value: 'Pacific/Tarawa',
      },
      {
        category: 'Pacific',
        country: 'Kiribati',
        code: 'LINT',
        name: 'Line Islands Time',
        locations: 'Kiritimati',
        value: 'Pacific/Kiritimati',
      },
      {
        category: 'Pacific',
        country: 'Kiribati',
        code: 'PHOT',
        name: 'Phoenix Islands Time',
        locations: 'Enderbury Island',
        value: 'Pacific/Enderbury',
      },
      {
        category: 'Pacific',
        country: 'Tuvalu',
        code: 'TVT',
        name: 'Tuvalu Time',
        locations: 'Funafuti',
        value: 'Pacific/Funafuti',
      },
      {
        category: 'Pacific',
        country: 'French Polynesia',
        code: 'TAHT',
        name: 'Tahiti Time',
        locations: 'Papeete',
        value: 'Pacific/Tahiti',
      },
      {
        category: 'Pacific',
        country: 'Federated States of Micronesia',
        code: 'YAPT',
        name: 'Yap Time',
        locations: 'Colonia, Weno',
        value: 'Pacific/Chuuk',
      },
      {
        category: 'Pacific',
        country: 'Federated States of Micronesia',
        code: 'PONT',
        name: 'Pohnpei Time',
        locations: 'Palikir, Tofol',
        value: 'Pacific/Pohnpei',
      },
      {
        category: 'Pacific',
        country: 'Nauru',
        code: 'NRT',
        name: 'Nauru Time',
        locations: 'Yaren',
        value: 'Pacific/Nauru',
      },
      {
        category: 'Pacific',
        country: 'Niue',
        code: 'NUT',
        name: 'Niue Time',
        locations: 'Alofi',
        value: 'Pacific/Niue',
      },
      {
        category: 'Pacific',
        country: 'New Caledonia',
        code: 'NCT',
        name: 'New Caledonia Time',
        locations: 'Noumea',
        value: 'Pacific/Noumea',
      },
      {
        category: 'Pacific',
        country: 'Palau',
        code: 'PWT',
        name: 'Palau Time',
        locations: 'Koror',
        value: 'Pacific/Palau',
      },
      {
        category: 'Pacific',
        country: 'Pitcairn Islands',
        code: 'PST',
        name: 'Pitcairn Standard Time',
        locations: 'Adamstown',
        value: 'Pacific/Pitcairn',
      },
      {
        category: 'Pacific',
        country: 'Cook Islands',
        code: 'CKT',
        name: 'Cook Islands Time',
        locations: 'Avarua',
        value: 'Pacific/Rarotonga',
      },
      {
        category: 'Pacific',
        country: 'Northern Mariana Islands',
        code: 'ChST',
        name: 'Chamorro Standard Time',
        locations: 'Saipan',
        value: 'Pacific/Saipan',
      },
      {
        category: 'Pacific',
        country: 'Wallis and Futuna',
        code: 'WFT',
        name: 'Wallis and Futuna Time',
        locations: 'Mata-Utu',
        value: 'Pacific/Wallis',
      },
    ],
  },
  {
    groupName: 'Asia',
    result: [
      {
        category: 'Asia',
        country: 'Western New Guinea',
        code: 'WIT',
        name: 'Eastern Indonesian Time',
        locations: 'Jayapura',
        value: 'Asia/Jayapura',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'YEKT',
        name: 'Yekaterinburg Time',
        locations: 'Yekaterinburg, Perm, Chelyabinsk',
        value: 'Asia/Yekaterinburg',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'OMT',
        name: 'Omsk Time',
        locations: 'Omsk',
        value: 'Asia/Omsk',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'NOVT',
        name: 'Novosibirsk Time',
        locations: 'Novosibirsk',
        value: 'Asia/Novosibirsk',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'KRAS',
        name: 'Krasnoyarsk Time',
        locations: 'Krasnoyarsk',
        value: 'Asia/Krasnoyarsk',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'IRKT',
        name: 'Irkutsk Time',
        locations: 'Irkutsk, Ulan-Ude',
        value: 'Asia/Irkutsk',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'YAKT',
        name: 'Yakutsk Time',
        locations: 'Yakutsk',
        value: 'Asia/Yakutsk',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'VLAT',
        name: 'Vladivostok Time',
        locations: 'Vladivostok, Khabarovsk',
        value: 'Asia/Vladivostok',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'MAG',
        name: 'Magadan Time',
        locations: 'Magadan',
        value: 'Asia/Magadan',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'SAKT',
        name: 'Sakhalin Time',
        locations: 'Yuzhno-Sakhalinsk',
        value: 'Asia/Sakhalin',
      },
      {
        category: 'Asia',
        country: 'Russia',
        code: 'KAMT',
        name: 'Kamchatka Time',
        locations: 'Petropavlovsk-Kamchatsky',
        value: 'Asia/Kamchatka',
      },
      {
        category: 'Asia',
        country: 'Yemen',
        code: 'AST',
        name: 'Arabian Standard Time',
        locations: 'Aden',
        value: 'Asia/Aden',
      },
      {
        category: 'Asia',
        country: 'Kazakhstan',
        code: 'AQTT',
        name: 'Aqtau Time',
        locations: 'Aktau, Atyrau',
        value: 'Asia/Aqtau',
      },
      {
        category: 'Asia',
        country: 'Kazakhstan',
        code: 'AQTO',
        name: 'Aqtobe Time',
        locations: 'Aktobe',
        value: 'Asia/Aqtobe',
      },
      {
        category: 'Asia',
        country: 'Kazakhstan',
        code: 'ALMT',
        name: 'Almaty Time',
        locations: 'Almaty',
        value: 'Asia/Almaty',
      },
      {
        category: 'Asia',
        country: 'Jordan',
        code: 'EET',
        name: 'Eastern European Time',
        locations: 'Amman',
        value: 'Asia/Amman',
      },
      {
        category: 'Asia',
        country: 'Turkmenistan',
        code: 'TMT',
        name: 'Turkmenistan Time',
        locations: 'Ashgabat, Ashkhabad',
        value: 'Asia/Ashgabat',
      },
      {
        category: 'Asia',
        country: 'Iraq',
        code: 'AST',
        name: 'Arabian Standard Time',
        locations: 'Baghdad',
        value: 'Asia/Baghdad',
      },
      {
        category: 'Asia',
        country: 'Bahrain',
        code: 'AST',
        name: 'Arabian Standard Time',
        locations: 'Manama',
        value: 'Asia/Bahrain',
      },
      {
        category: 'Asia',
        country: 'Azerbaijan',
        code: 'AZT',
        name: 'Azerbaijan Time',
        locations: 'Baku',
        value: 'Asia/Baku',
      },
      {
        category: 'Asia',
        country: 'Thailand',
        code: 'ICT',
        name: 'Indochina Time',
        locations: 'Bangkok',
        value: 'Asia/Bangkok',
      },
      {
        category: 'Asia',
        country: 'Lebanon',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Beirut',
        value: 'Asia/Beirut',
      },
      {
        category: 'Asia',
        country: 'Kyrgyzstan',
        code: 'KGT',
        name: 'Kyrgyzstan Time',
        locations: 'Bishkek',
        value: 'Asia/Bishkek',
      },
      {
        category: 'Asia',
        country: 'Brunei',
        code: 'BNT',
        name: 'Brunei Darussalam Time',
        locations: 'Bandar Seri Begawan',
        value: 'Asia/Brunei',
      },
      {
        category: 'Asia',
        country: 'India',
        code: 'IST',
        name: 'Indian Standard Time',
        locations: 'Kolkata, Mumbai, New Delhi',
        value: 'Asia/Kolkata',
      },
      {
        category: 'Asia',
        country: 'Mongolia',
        code: 'CHOT',
        name: 'Choibalsan Time',
        locations: 'Choibalsan',
        value: 'Asia/Choibalsan',
      },
      {
        category: 'Asia',
        country: 'Mongolia',
        code: 'HOVT',
        name: 'Hovd Time',
        locations: 'Hovd',
        value: 'Asia/Hovd',
      },
      {
        category: 'Asia',
        country: 'Mongolia',
        code: 'ULAT',
        name: 'Ulaanbaatar Time',
        locations: 'Ulaanbaatar',
        value: 'Asia/Ulaanbaatar',
      },
      {
        category: 'Asia',
        country: 'China',
        code: 'CST',
        name: 'China Standard Time',
        locations: 'Beijing, Shanghai,',
        value: 'Asia/Shanghai',
      },
      {
        category: 'Asia',
        country: 'China',
        code: 'XJT',
        name: 'Xinjiang Time',
        locations: 'Kashgar, Urumqi',
        value: 'Asia/Urumqi',
      },
      {
        category: 'Asia',
        country: 'Sri Lanka',
        code: 'IST',
        name: 'Indian Standard Time',
        locations: 'Colombo',
        value: 'Asia/Colombo',
      },
      {
        category: 'Asia',
        country: 'Bangladesh',
        code: 'BDT',
        name: 'Bangladesh Time',
        locations: 'Dhaka',
        value: 'Asia/Dhaka',
      },
      {
        category: 'Asia',
        country: 'Syria',
        code: 'EET',
        name: 'Eastern European Time',
        locations: 'Damascus',
        value: 'Asia/Damascus',
      },
      {
        category: 'Asia',
        country: 'East Timor',
        code: 'TLT',
        name: 'East Timor Time',
        locations: 'Dili',
        value: 'Asia/Dili',
      },
      {
        category: 'Asia',
        country: 'United Arab Emirates',
        code: 'GST',
        name: 'Gulf Standard Time',
        locations: 'Dubai',
        value: 'Asia/Dubai',
      },
      {
        category: 'Asia',
        country: 'Tajikistan',
        code: 'TJT',
        name: 'Tajikistan Time',
        locations: 'Dushanbe',
        value: 'Asia/Dushanbe',
      },
      {
        category: 'Asia',
        country: 'Northern Cyprus',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Famagusta, Nicosia',
        value: 'Asia/Famagusta',
      },
      {
        category: 'Asia',
        country: 'Palestine',
        code: 'EET',
        dstCode: 'EEST',
        name: 'Eastern European Time',
        dstName: 'Eastern European Summer Time',
        locations: 'Gaza, Hebron',
        value: 'Asia/Gaza',
      },
      {
        category: 'Asia',
        country: 'Vietnam',
        code: 'ICT',
        name: 'Indochina Time',
        locations: 'Ho Chi Minh City',
        value: 'Asia/Ho_Chi_ Minh',
      },
      {
        category: 'Asia',
        country: 'Hong Kong',
        code: 'HKT',
        name: 'Hong Kong Time',
        locations: 'Hong Kong',
        value: 'Asia/Hong_Kong',
      },
      {
        category: 'Asia',
        country: 'Indonesia',
        code: 'WIB',
        name: 'Western Indonesian Time',
        locations: 'Jakarta',
        value: 'Asia/Jakarta',
      },
      {
        category: 'Asia',
        country: 'Indonesia',
        code: 'WITA',
        name: 'Central Indonesia Time',
        locations: 'Makassar',
        value: 'Asia/Makassar',
      },
      {
        category: 'Asia',
        country: 'Taiwan',
        code: 'TST',
        name: 'Taipei Standard Time',
        locations: 'Taipei, Taichung',
        value: 'Asia/Taipei',
      },
      {
        category: 'Asia',
        country: 'Korea',
        code: 'KST',
        name: 'Korea Standard Time',
        locations: 'Seoul, Busan',
        value: 'Asia/Seoul',
      },
      {
        category: 'Asia',
        country: 'Afghanistan',
        code: 'AFT',
        name: 'Afghanistan Time',
        locations: 'Kabul, Herat',
        value: 'Asia/Kabul',
      },
      {
        category: 'Asia',
        country: 'Iran',
        code: 'IRST',
        name: 'Iran Standard Time',
        locations: 'Tehran, Isfahan',
        value: 'Asia/Tehran',
      },
      {
        category: 'Asia',
        country: 'Malaysia',
        code: 'MYT',
        name: 'Malaysia Time',
        locations: 'Kuala Lumpur, Penang',
        value: 'Asia/Kuala_Lumpur',
      },
      {
        category: 'Asia',
        country: 'Myanmar',
        code: 'MMT',
        name: 'Myanmar Standard Time',
        locations: 'Yangon, Naypyidaw',
        value: 'Asia/Yangon',
      },
      {
        category: 'Asia',
        country: 'Nepal',
        code: 'NPT',
        name: 'Nepal Time',
        locations: 'Kathmandu, Patan',
        value: 'Asia/Kathmandu',
      },
      {
        category: 'Asia',
        country: 'Oman',
        code: 'GST',
        name: 'Gulf Standard Time',
        locations: 'Muscat, Sohar',
        value: 'Asia/Muscat',
      },
      {
        category: 'Asia',
        country: 'Pakistan',
        code: 'PKT',
        name: 'Pakistan Standard Time',
        locations: 'Islamabad, Lahore',
        value: 'Asia/Karachi',
      },
      {
        category: 'Asia',
        country: 'Philippines',
        code: 'PST',
        name: 'Philippine Standard Time',
        locations: 'Manila, Davao',
        value: 'Asia/Manila',
      },
      {
        category: 'Asia',
        country: 'Qatar',
        code: 'AST',
        name: 'Arabia Standard Time',
        locations: 'Doha',
        value: 'Asia/Qatar',
      },
      {
        category: 'Asia',
        country: 'Saudi Arabia',
        code: 'AST',
        name: 'Arabia Standard Time',
        locations: 'Riyadh,  Mecca',
        value: 'Asia/Riyadh',
      },
      {
        category: 'Asia',
        country: 'Singapore',
        code: 'SGT',
        name: 'Singapore Standard Time',
        locations: 'Singapore',
        value: 'Asia/Singapore',
      },
      {
        category: 'Asia',
        country: 'Armenia',
        code: 'AMT',
        name: 'Armenia Time',
        locations: 'Yerevan, Vanadzor',
        value: 'Asia/Yerevan',
      },
      {
        category: 'Asia',
        country: 'Laos',
        code: 'ICT',
        name: 'Indochina Time',
        locations: 'Vientiane, Savannakhet',
        value: 'Asia/Vientiane',
      },
      {
        category: 'Asia',
        country: 'Japan',
        code: 'JST',
        name: 'Japan Standard Time',
        locations: 'Tokyo, Osaka',
        value: 'Asia/Tokyo',
      },
      {
        category: 'Asia',
        country: 'Bhutan',
        code: 'BTT',
        name: 'Bhutan Time',
        locations: 'Thimphu, Punakha',
        value: 'Asia/Thimphu',
      },
      {
        category: 'Asia',
        country: 'Georgia',
        code: 'GET',
        name: 'Georgia Standard Time',
        locations: 'Tbilisi, Batumi',
        value: 'Asia/Tbilisi',
      },
      {
        category: 'Asia',
        country: 'Uzbekistan',
        code: 'UZT',
        name: 'Uzbekistan Time',
        locations: 'Tashkent, Bukhara',
        value: 'Asia/Tashkent',
      },
      {
        category: 'Asia',
        country: 'South Korea',
        code: 'KST',
        name: 'Korea Standard Time',
        locations: 'Seoul, Incheon',
        value: 'Asia/Seoul',
      },
      {
        category: 'Asia',
        country: 'North Korea',
        code: 'KST',
        name: 'Korea Standard Time',
        locations: 'Pyongyang, Chongjin',
        value: 'Asia/Pyongyang',
      },
      {
        category: 'Asia',
        country: 'Israel',
        code: 'IDT',
        name: 'Israel Daylight Time',
        locations: 'Jerusalem, Tel Aviv',
        value: 'Asia/Jerusalem',
      },
    ],
  },
  {
    groupName: 'Africa',
    result: [
      {
        category: 'Africa',
        country: 'Kwajalein',
        code: 'MHT',
        name: 'Marshall Islands Time',
        locations: 'Kwajalein Atoll',
        value: 'Pacific/Kwajalein',
      },
      {
        category: 'Africa',
        country: 'Libya',
        code: 'LYST',
        name: 'Libya Standard Time',
        locations: 'Tripoli',
        value: 'Africa/Tripoli',
      },
      {
        category: 'Africa',
        country: "Côte d'Ivoire",
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Abidjan',
        value: 'Africa/Abidjan',
      },
      {
        category: 'Africa',
        country: 'Ghana',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Accra',
        value: 'Africa/Accra',
      },
      {
        category: 'Africa',
        country: 'Ethiopia',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Addis Ababa',
        value: 'Africa/Addis_Ababa',
      },
      {
        category: 'Africa',
        country: 'Algeria',
        code: 'CET',
        name: 'Central European Time',
        locations: 'Algiers',
        value: 'Africa/Algiers',
      },
      {
        category: 'Africa',
        country: 'Eritrea',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Asmara',
        value: 'Africa/Asmara',
      },
      {
        category: 'Africa',
        country: 'Mali',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Bamako',
        value: 'Africa/Bamako',
      },
      {
        category: 'Africa',
        country: 'Central African Republic',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Bangui',
        value: 'Africa/Bangui',
      },
      {
        category: 'Africa',
        country: 'Gambia',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Banjul',
        value: 'Africa/Banjul',
      },
      {
        category: 'Africa',
        country: 'Guinea-Bissau',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Bissau',
        value: 'Africa/Bissau',
      },
      {
        category: 'Africa',
        country: 'Malawi',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Lilongwe, Blantyre',
        value: 'Africa/Blantyre',
      },
      {
        category: 'Africa',
        country: 'Republic of the Congo',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Brazzaville',
        value: 'Africa/Brazzaville',
      },
      {
        category: 'Africa',
        country: 'Burundi',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Bujumbura',
        value: 'Africa/Bujumbura',
      },
      {
        category: 'Africa',
        country: 'Egypt',
        code: 'EET',
        name: 'Eastern European Time',
        locations: 'Cairo',
        value: 'Africa/Cairo',
      },
      {
        category: 'Africa',
        country: 'Morocco',
        code: 'WET',
        name: 'Western European Time',
        locations: 'Casablanca, Rabat',
        value: 'Africa/Casablanca',
      },
      {
        category: 'Africa',
        country: 'Guinea',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Conakry',
        value: 'Africa/Conakry',
      },
      {
        category: 'Africa',
        country: 'Senegal',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Dakar',
        value: 'Africa/Dakar',
      },
      {
        category: 'Africa',
        country: 'Tanzania',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Dar es Salaam',
        value: 'Africa/Dar_es_Salaam',
      },
      {
        category: 'Africa',
        country: 'Djibouti',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Djibouti City',
        value: 'Africa/Djibouti',
      },
      {
        category: 'Africa',
        country: 'Cameroon',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Yaoundé',
        value: 'Africa/Douala',
      },
      {
        category: 'Africa',
        country: 'Western Sahara',
        code: 'WET',
        name: 'Western European Time',
        locations: 'Laayoune',
        value: 'Africa/El_Aaiun',
      },
      {
        category: 'Africa',
        country: 'Sierra Leone',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Freetown',
        value: 'Africa/Freetown',
      },
      {
        category: 'Africa',
        country: 'Botswana',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Gaborone',
        value: 'Africa/Gaborone',
      },
      {
        category: 'Africa',
        country: 'Zimbabwe',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Harare',
        value: 'Africa/Harare',
      },
      {
        category: 'Africa',
        country: 'South Africa',
        code: 'SAST',
        name: 'South Africa Standard Time',
        locations: 'Cape Town, Pretoria, Johannesburg',
        value: 'Africa/Johannesburg',
      },
      {
        category: 'Africa',
        country: 'South Sudan',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Juba',
        value: 'Africa/Juba',
      },
      {
        category: 'Africa',
        country: 'Uganda',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Kampala',
        value: 'Africa/Kampala',
      },
      {
        category: 'Africa',
        country: 'Sudan',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Khartoum',
        value: 'Africa/Khartoum',
      },
      {
        category: 'Africa',
        country: 'Rwanda',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Kigali',
        value: 'Africa/Kigali',
      },
      {
        category: 'Africa',
        country: 'Democratic Republic of the Congo',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Kinshasa',
        value: 'Africa/Kinshasa',
      },
      {
        category: 'Africa',
        country: 'Nigeria',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Lagos, Abuja',
        value: 'Africa/Lagos',
      },
      {
        category: 'Africa',
        country: 'Gabon',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Libreville',
        value: 'Africa/Libreville',
      },
      {
        category: 'Africa',
        country: 'Togo',
        code: 'GMT',
        name: 'Greenwich Mean Time',
        locations: 'Lomé',
        value: 'Africa/Lome',
      },
      {
        category: 'Africa',
        country: 'Angola',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Luanda',
        value: 'Africa/Luanda',
      },
      {
        category: 'Africa',
        country: 'Zambia',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Lusaka',
        value: 'Africa/Lusaka',
      },
      {
        category: 'Africa',
        country: 'Equatorial Guinea',
        code: 'WAT',
        name: 'West Africa Time',
        locations: 'Malabo',
        value: 'Africa/Malabo',
      },
      {
        category: 'Africa',
        country: 'Mozambique',
        code: 'CAT',
        name: 'Central Africa Time',
        locations: 'Maputo',
        value: 'Africa/Maputo',
      },
      {
        category: 'Africa',
        country: 'Lesotho',
        code: 'SAST',
        name: 'South Africa Standard Time',
        locations: 'Maseru',
        value: 'Africa/Maseru',
      },
      {
        category: 'Africa',
        country: 'Eswatini',
        code: 'SAST',
        name: 'South Africa Standard Time',
        locations: 'Mbabane',
        value: 'Africa/Mbabane',
      },
      {
        category: 'Africa',
        country: 'Somalia',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Mogadishu',
        value: 'Africa/Mogadishu',
      },
      {
        category: 'Africa',
        country: 'Seychelles',
        code: 'SAST',
        name: 'South Africa Standard Time',
        locations: 'Victoria',
        value: 'Indian/Mahe',
      },
      {
        category: 'Africa',
        country: 'Comoros',
        code: 'EAT',
        name: 'East Africa Time',
        locations: 'Moroni',
        value: 'Africa/Comoros',
      },
    ],
  },
  {
    groupName: 'Indian',
    result: [
      {
        category: 'Indian',
        country: 'Madagascar',
        code: 'MGT',
        name: 'Madagascar Time',
        locations: 'Antananarivo',
        value: 'Indian/Antananarivo',
      },
      {
        category: 'Indian',
        country: 'British Indian Ocean Territory',
        code: 'IOT',
        name: 'Indian Ocean Time',
        locations: 'Diego Garcia',
        value: 'Indian/Chagos',
      },
      {
        category: 'Indian',
        country: 'Christmas Island',
        code: 'CWST',
        name: 'Christmas Island Time',
        locations: 'Flying Fish Cove',
        value: 'Indian/Christmas',
      },
      {
        category: 'Indian',
        country: 'Cocos Island',
        code: 'CCT',
        name: 'Cocos Islands Time',
        locations: 'West Island',
        value: 'Indian/Cocos',
      },
      {
        category: 'Indian',
        country: 'French Southern and Antarctic Lands',
        code: 'REYT',
        name: 'Réunion Time',
        locations: 'Kerguelen Islands, Mamoudzou, Saint-Denis',
        value: 'Indian/Reunion',
      },
      {
        category: 'Indian',
        country: 'Maldives',
        code: 'MVT',
        name: 'Maldives Time',
        locations: 'Malé',
        value: 'Indian/Maldives',
      },
      {
        category: 'Indian',
        country: 'Mauritius',
        code: 'MUT',
        name: 'Mauritius Time',
        locations: 'Port Louis',
        value: 'Indian/Mauritius',
      },
    ],
  },
];

export const TIMEZONE_FLAT_LIST = TIMEZONE_LIST.flatMap((list) => list.result);
